import React, { useState } from "react";
import colors from "../../assets/colors.json";
import { useMediaQuery } from "react-responsive";
import { TabLink } from "../Dashboard/styles/dashboard.style";
import Allowance from "../../components/HR/Allowance";
import Deductions from "../../components/HR/Deductions";
import PayrollSchedule from "../../components/HR/PayrollSchedule";
const Payroll = () => {
  const isTab = useMediaQuery({ maxWidth: 992 });
  const [tab, setTab] = useState(3);

  return (
    <>
      <div
        style={{
          width: isTab ? "100%" : "70%",
          display: "flex",
          alignItems: "center",
          padding: "8px 16px",
          backgroundColor: colors.secondary,
          borderRadius: "5px",
          flexWrap: "wrap",
        }}
      >
        <TabLink isActive={tab === 1} onClick={() => setTab(1)}>
          Allowance
        </TabLink>
        <TabLink isActive={tab === 2} onClick={() => setTab(2)}>
          Deductions
        </TabLink>
        <TabLink isActive={tab === 3} onClick={() => setTab(3)}>
          Payroll Schedule
        </TabLink>
      </div>

      {tab === 1 && <Allowance />}
      {tab === 2 && <Deductions />}
      {tab === 3 && <PayrollSchedule />}
    </>
  );
};

export default Payroll;
